import styled from 'styled-components';

/**
 * Use this component to wrap all icons so that styles can be applied to any
 * icon type from within a parent component, e.g:
 *
 * const Button = styled.button.attrs({ type: 'button' })`
 *   ${Icon} {
 *     margin-left: 4px;
 *   }
 * `
 */
export const Icon = styled.svg``;

Icon.defaultProps = {
	width: '1em',
	height: '1em',
	viewBox: '0 0 32 32',
	fill: '#d8d8db',
};
